// extracted by mini-css-extract-plugin
export const swiperWrapper = "productGallery-module--swiperWrapper--3KK9_";
export const galeryWrapper = "productGallery-module--galeryWrapper--1P-RR";
export const commandsWrapper = "productGallery-module--commandsWrapper--1nBze";
export const swiperButtonPrev = "productGallery-module--swiperButtonPrev--tKfZA";
export const swiperButtonNext = "productGallery-module--swiperButtonNext--3CwQm";